import React from 'react';
import type { IconType } from 'react-icons';

interface IconProps {
  component: IconType;
  className?: string;
}

const Icon: React.FC<IconProps> = ({ component: Component, className }) => {
  // Type assertion to work around react-icons type incompatibility with React 19
  const IconComponent = Component as React.ComponentType<{ className?: string }>;
  return React.createElement(IconComponent, { className });
};

export default Icon;




